module.exports = __webpack_public_path__ + "img/GDQ-matcirkel_30.76217efc.gif";